<template>

    <div>

        <h1 class="mt-4">Företagskunder<button class="btn btn-primary btn-sm ms-6" @click="createCompany()">
                        Lägg till företagskund
                    </button></h1>

        <div class="content-container">

            <div class="row g-3 mb-4">

                <div class="col-24 col-md-6">
                    <input type="text"
                           class="form-control new-list-group-field"
                           placeholder="Sök namn, kontaktuppgifter, övriga fält"
                           v-model="settings.query.text"
                    >
                </div>

                <div class="col-24 col-md-3">
                    <select class="form-select new-list-group-field" v-model="settings.query.subscription">
                        <option :value="null">Abonnemang</option>
                        <option :key="'s_'+subscription.id" :value="subscription.id" v-for="subscription in options.subscriptions">
                            {{ subscription.name }}
                        </option>
                    </select>

                </div>

                <div class="col-24 col-md-3">
                    <select class="form-select new-list-group-field" v-model="settings.query.status">
                        <option :value="null">Status</option>
                        <option>Prospect</option>
                        <option>Aktiv</option>
                        <option>Inaktiv</option>
                        <option>Avslutad</option>
                        <option>Inaktivt prospect</option>
                    </select>
                </div>

                <div class="col-24 col-md-3">
                    <select class="form-select new-list-group-field" v-model="settings.query.admin_contract">
                        <option :value="null">Avtalsansvarig</option>
                        <option :key="'contract_'+admin.id" :value="admin.id" v-for="admin in options.admins">
                            {{ admin.name }}
                        </option>
                    </select>
                </div>

                <div class="col-24 col-md-3">
                    <select class="form-select new-list-group-field" v-model="settings.query.admin_contact">
                        <option :value="null">Kontaktperson</option>
                        <option :key="'contact_'+admin.id" :value="admin.id" v-for="admin in options.admins">
                            {{ admin.name }}
                        </option>
                    </select>
                </div>

                <div class="col-24 col-md-3">
                    <select class="form-select new-list-group-field" v-model="settings.query.admin_next_contact">
                        <option :value="null">Nästa kontakt</option>
                        <option :key="'contact_'+admin.id" :value="admin.id" v-for="admin in options.admins">
                            {{ admin.name }}
                        </option>
                    </select>
                </div>

                <div class="col-24 col-md-3 d-flex justify-content-end">

                    <button class="btn btn-primary btn-sm" @click="openExportModal()">Spara Excel
                        <div class="tooltip-label">Ladda ner en Excel-fil med företagskunder.</div>
                    </button>
                </div>

            </div>

            <list ref="list" :settings="settings" :query.sync="settings.query">
                <div slot="item-row" slot-scope="props">
                    <div class="row g-3">
                        <div class="col d-none d-md-flex col-md-1">
                            <span>{{ props.item.id }}</span>
                        </div>
                        <div class="col col-18 col-md-4">
                            <div class="w-100" style="font-weight: 400;">
                                <span v-if="props.item.name">{{ props.item.name }}</span>
                                <span v-else><i>Ny företagskund</i></span>
                            </div>
                            <div><span style="font-size: 13px;">{{ props.item.address_city }}</span></div>
                        </div>
                        <div class="col d-none d-md-flex col-md-5">

                            <!-- Där ett abonnemang sagt upp och ett nytt påbörjats -->
                            <div class="tooltip-target" v-if="activeContract(props.item.contracts) && activeContract(props.item.contracts).ends_at && pendingContract(props.item.contracts)">
                                <span style="font-weight: 400;">{{ activeContract(props.item.contracts).subscription.name }}</span>
                                <span class="badge badge-primary" style="font-size: 9px;">
                                    Ändrat
                                </span>
                                <div v-if="firstContractStart(props.item.contracts)" style="font-size: 13px;">
                                    Ansluten {{ firstContractStart(props.item.contracts) }}
                                </div>
                                <div class="tooltip-label" style="width: 320px;">
                                    {{ activeContract(props.item.contracts).subscription.name }} avslutas {{ activeContract(props.item.contracts).ends_at }}<br>
                                    {{ pendingContract(props.item.contracts).subscription.name }} påbörjas {{ pendingContract(props.item.contracts).starts_at }}<br>
                                    Publikt namn: {{ activeContract(props.item.contracts).subscription.name_public }}
                                </div>
                            </div>

                            <!-- För aktiva eller aktiva och uppsagda abonnemang -->
                            <div class="tooltip-target" v-else-if="activeContract(props.item.contracts)">
                                <span style="font-weight: 400;">{{ activeContract(props.item.contracts).subscription.name }}</span>
                                <span class="badge badge-dark" style="font-size: 9px;" v-if="activeContract(props.item.contracts).ends_at">
                                    Uppsagt
                                </span>
                                <div v-if="firstContractStart(props.item.contracts)" style="font-size: 13px;">
                                    Ansluten {{ firstContractStart(props.item.contracts) }}
                                </div>
                                <div class="tooltip-label">
                                    <span v-if="activeContract(props.item.contracts).ends_at">Uppsagt till {{ activeContract(props.item.contracts).ends_at }}<br></span>
                                    Publikt namn: {{ activeContract(props.item.contracts).subscription.name_public }}
                                </div>
                            </div>

                            <!-- För aktiverade men ej ännu gällande abonneamng (innan startdatum) -->
                            <div class="tooltip-target" v-else-if="pendingContract(props.item.contracts)">
                                <span style="font-weight: 400;">{{ pendingContract(props.item.contracts).subscription.name }}</span>
                                <span class="badge badge-primary" style="font-size: 9px;">Nytt</span>
                                <div v-if="firstContractStart(props.item.contracts)" style="font-size: 13px;">
                                    Ansluten {{ firstContractStart(props.item.contracts) }}
                                </div>
                                <div class="tooltip-label">
                                    Blir aktivt {{ pendingContract(props.item.contracts).starts_at }}<br>
                                    Publikt namn: {{ pendingContract(props.item.contracts).subscription.name_public }}
                                </div>
                            </div>

                            <div class="tooltip-target" v-else-if="previousContract(props.item.contracts)">
                                <span style="text-decoration: line-through;">{{ previousContract(props.item.contracts).subscription.name }}</span>
                                <span class="badge badge-info" style="font-size: 9px;" v-if="previousContract(props.item.contracts).ends_at">Avslutat</span>
                                <div v-if="firstContractStart(props.item.contracts)" style="font-size: 13px;">
                                    Ansluten {{ firstContractStart(props.item.contracts) }}
                                </div>
                                <div class="tooltip-label" v-if="previousContract(props.item.contracts).ends_at">
                                    Avslutatades {{ previousContract(props.item.contracts).ends_at }}<br>
                                    Publikt namn: {{ previousContract(props.item.contracts).subscription.name_public }}
                                </div>
                            </div>

                            <div v-else>
                                <i>Inget påbörjat avtal</i>
                            </div>

                        </div>
                        <div class="col d-none d-md-flex col-md-2">
                            <span>{{ props.item.workplaces_count }} st </span>
                        </div>
                        <div class="col d-none d-md-flex col-md-2">
                            <div class="tooltip-target">
                                <span>{{ props.item.treatments_last_month_count }} st / {{ props.item.treatments_count }} st</span>
                                <div class="tooltip-label">
                                    Förra månaden: <b>{{ props.item.treatments_last_month_count }} st</b><br>
                                    Totalt för kund: <b>{{ props.item.treatments_count }}</b>
                                </div>
                            </div>
                        </div>
                        <div class="col d-none d-md-flex col-md-2" style="font-size: 16px;">
                            <span class="badge badge-primary ms-0" v-if="props.item.status == 'Aktiv'">{{ props.item.status }}</span>
                            <span class="badge badge-warning ms-0" v-else-if="props.item.status == 'Prospect'">{{ props.item.status }}</span>
                            <span class="badge badge-info ms-0" v-else>{{ props.item.status }}</span>
                        </div>
                        <div class="col d-none d-md-flex col-md-1">
                            <span>{{ props.item.priority }}</span>
                        </div>
                        <div class="col d-none d-md-flex col-md-2">
                            <span>{{ props.item.next_contact_at }}</span>
                        </div>
                        <div class="col d-none d-md-flex col-md-2">
                            <span>{{ props.item.last_contact_at }}</span>
                        </div>
                        <div class="col col-6 col-md-3 d-flex justify-content-end">
                            <a :href="'/companies/'+props.item.id">
                                <button class="btn btn-primary btn-sm me-1">Hantera
                                    <div class="tooltip-label">Redigera och hantera företagskunden</div>
                                </button>
                            </a>
                            <button class="btn btn-danger btn-sm" v-if="props.item.contracts.length === 0">
                                <img src="/images/admin/icon-trash.svg" :disabled="deleter.submitted" @click="triggerDelete(props.item.id)">
                                <div class="tooltip-label">Du kan radera kunden fram till att det finns ett uppladdat avtal.</div>
                            </button>
                            <button class="btn btn-danger btn-sm inactive" v-else>
                                <img src="/images/admin/icon-trash.svg">
                                <div class="tooltip-label">Du kan radera kunden fram till att det finns ett uppladdat avtal.</div>
                            </button>
                        </div>
                    </div>
                </div>
            </list>
        </div>
    </div>

</template>

<script>
import axios from 'axios'

import lister from '../../../../shared/mixins/lister'
import deleter from '../../../../shared/mixins/deleter'

import { activeContract, pendingContract, previousContract } from '../../../../shared/methods/contract-filter'

export default {

    mixins: [
        lister,
        deleter
    ],

    props: {
        options: {
            required: true
        }
    },

    data () {
        return {

            settings: {
                url: '/companies/list',
                query: {
                    text: '',
                    subscription: null,
                    status: null,
                    admin_contract: null,
                    admin_contact: null,
                    admin_next_contact: null
                },
                columns: [
                    { column: 'id', name: 'ID', class: 'col d-none d-md-flex col-md-1', sortable: true, default: true },
                    { column: 'name', name: 'Företag', class: 'col col-18 col-md-4', sortable: true },
                    { column: 'subscription', name: 'Abonnemang', class: 'col d-none d-md-flex col-md-5 unsortable', sortable: false },
                    { column: 'workplaces_count', name: 'Arb.platser', class: 'col d-none d-md-flex col-md-2', sortable: true },
                    { column: 'treatments_last_month_count', name: 'Behandl.', class: 'col d-none d-md-flex col-md-2', sortable: true },
                    { column: 'status', name: 'Status', class: 'col d-none d-md-flex col-md-2', sortable: true },
                    { column: 'priority', name: 'Prio', class: 'col d-none d-md-flex col-md-1', sortable: true },
                    { column: 'next_contact_at', name: 'Nästa k.', class: 'col d-none d-md-flex col-md-2', sortable: true },
                    { column: 'last_contact_at', name: 'Senaste k.', class: 'col d-none d-md-flex col-md-2', sortable: true }
                ],
                bulk_actions: [],
                export_fields: [
                    { column: 'id', name: 'ID' },
                    { column: 'name', name: 'Företagsnamn' },
                    { column: 'organization_number', name: 'Organisationsnummer' },
                    { column: 'address_street_1', name: 'Adress' },
                    { column: 'address_street_2', name: 'Adress rad 2' },
                    { column: 'address_zip', name: 'Postnummer' },
                    { column: 'address_city', name: 'Ort' },
                    { column: 'invoice_email', name: 'E-post för faktura' },
                    { column: 'status', name: 'Status' },
                    { column: 'subscription_name', name: 'Aktivt abonnemang' },
                    { column: 'subscription_name_public', name: 'Publikt namn' },
                    { column: 'subscription_nice_name', name: 'Abonnemangstyp' },
                    { column: 'quota.treatments_total', name: 'Aktuell pott' },
                    { column: 'quota.treatments_used', name: 'Nyttjat aktuell pott' },
                    { column: 'quota_percent', name: 'Procent nyttjat aktuell pott' },
                    { column: 'treatments_last_month_count', name: 'Nyttjade behandlingar föregående månad' },
                    { column: 'treatments_count', name: 'Nyttjade behandlingar totalt' },
                    { column: 'workplaces_count', name: 'Antal arbetsplatser' },
                    { column: 'employees_count', name: 'Antal anställda' },
                    { column: 'created_at', name: 'Skapad' },
                    { column: 'first_contract_activated_at', name: 'Först ansluten' },
                    { column: 'employee_part_payment_type_name', name: 'Delbetalning' },
                    { column: 'employee_notice_method_name', name: 'Notismetod' },
                    { column: 'open_registration_is_active', name: 'Registreringssida' },
                    { column: 'next_contact_at', name: 'Nästa kontakt' },
                    { column: 'last_contact_at', name: 'Senaste kontakt' },
                    { column: 'contract_name', name: 'Avtalsansvarig' },
                    { column: 'contract_title', name: 'Titel' },
                    { column: 'contract_email', name: 'E-post' },
                    { column: 'contract_phone_1', name: 'Telefonnummer 1' },
                    { column: 'contract_phone_2', name: 'Telefonnummer 2' },
                    { column: 'admin_id_contract', name: 'Hälsoresurs avtalsansvarig' },
                    { column: 'admin_id_contact_1', name: 'Hälsoresurs kontaktperson 1' },
                    { column: 'admin_id_contact_2', name: 'Hälsoresurs kontaktperson 2' }

                    // Ev. loop av alla kontaktpersoner

                ]
            }
        }
    },

    computed: {
        deleterUrl () {
            return '/companies'
        }
    },

    methods: {
        createCompany () {
            axios.post('/companies')
                .then(response => {
                    window.location.href = '/companies/' + response.data.company_id
                })
        },

        triggerDelete (company_id) {
            if (!confirm('Vill du verkligen radera företaget?')) {
                return
            }
            this.deleterDelete(company_id)
        },

        deleterSuccess () {
            bus.$emit(
                'notify',
                'Företaget har raderats'
            )
            this.refresh()
        },

        activeContract: activeContract,

        pendingContract: pendingContract,

        previousContract: previousContract,

        firstContractStart (contracts) {
            const firstContract = contracts[Object.keys(contracts)[0]]

            if (firstContract) {
                return firstContract.starts_at
            }
        }
    }
}
</script>
